
  import {Component, Prop, Vue} from 'vue-property-decorator';

  @Component({})
  export default class ProgressCircle extends Vue {
    @Prop({default: () => '0.32rem'}) private radius!: string;
    @Prop({default: () => 0}) private percent!: number;

    private dashArray = Math.PI * 100;

    get dashOffset() {
      return (1 - this.percent) * this.dashArray;
    }

    get color() {
      let color = this.$store.getters.background;
      if (!color) {
        color = '#4B9CFC';
      }
      return color;
    }

  }
